import { EntityType } from '@ge/models/constants';

import * as request from './api';

const BASE_URL = process.env.REACT_APP_DIGITAL_WIND_FARM_DAV_API;
const BASE_URL_ASSETS = process.env.REACT_APP_DIGITAL_WIND_FARM_DAV_ASSET_API;

export const fetchReportingAssetsData = async (params) => {
  return request.post('/dav/sites/contractual-asset-kpis', params, {
    baseURL: BASE_URL_ASSETS,
  });
};
// export const fetchReferencePeriodKpiDate = async (params) => {
//   return request.post('/dav/sites/reference-period-data', params, {
//     baseURL: BASE_URL_ASSETS,
//   });
// };

export const fetchReferencePeriodKpiDate = async (params) => {
  // console.log('[Reference Period] Request params:', params);
  // console.log('[Reference Period] Base URL:', BASE_URL_ASSETS);

  try {
    const response = await request.post(
      '/dav/sites/reference-period-data',
      params,
      {
        baseURL: BASE_URL_ASSETS,
      }
    );

    // console.log('[Reference Period] API response:', response);
    return response;
  } catch (error) {
    // console.error('[Reference Period] API failed:', {
    //   status: error.response?.status,
    //   response: error.response?.data,
    //   message: error.message,
    //   params,
    // });

    throw error;
  }
};

export const fetchAllContracts = async (params) => {
  return request.post('/dav/sites/get-contracts', params, {
    baseURL: BASE_URL_ASSETS,
  });
};

export const getConditionsKpiData = ({
  categories,
  endDate,
  entityAggr,
  entityIds,
  entityType,
  filters,
  startDate,
  timeAggr,
}) =>
  request.post(
    '/dav/conditions-kpi-data',
    {
      categories,
      endDate,
      entityAggr,
      entityIds,
      entityType,
      filters,
      startDate,
      timeAggr,
    },
    {
      baseURL: BASE_URL,
    },
  );

export const getKpiData = ({
  categories,
  endDate,
  entityAggr,
  entityId,
  entityType,
  filters,
  startDate,
  timeAggr,
  passThrough,
  isMal,
  isReporting,
  isContract = false,
}) => {
  const url = {
    [EntityType.FLEET]: '/dav/fleets/kpi-data',
    [EntityType.REGION]: `/dav/regions/${entityId}/region-kpi-data`,
    [EntityType.SITE]: '/dav/sites/sites-kpi-data',
    [EntityType.TURBINE]: `/dav/assets/${entityId}/asset-kpi-data`,
  }[entityType];

  // is there a better way to handle this error?
  if (!url) {
    const error = `Entity type '${entityType}' is not recognized`;

    throw new Error(error);
  }

  return request.post(
    url,
    {
      categories,
      endDate,
      entityAggr,
      entityType,
      filters,
      startDate,
      timeAggr,
      passThrough,
      isMal,
      isReporting,
      isContract,
    },
    {
      baseURL: BASE_URL_ASSETS,
    },
  );
};
